module.exports = __webpack_public_path__ + "img/gift-clubfun-icon3.e1aa028e.png";